import React, { useState } from "react";
import ReactSlider from "react-slider";
import "../../style/slider.css";

const DurationSlider = () => {
  const [outbound, setOutbound] = useState([9, 19]);
  const [returnFlight, setReturnFlight] = useState([7, 16]);

  const formatTime = (val) => {
    return `${val.toString().padStart(2, "0")}:00`;
  };

  return (
    <div className="duration-card">
      <h3>Duration</h3>

      {/* Outbound Flight */}
      <p className="flight-label">
        Outbound flight, San Francisco (SFO)
      </p>

      <div className="time-row">
        <span>{formatTime(outbound[0])}</span>
        <span>{formatTime(outbound[1])}</span>
      </div>

      <ReactSlider
        className="slider"
        thumbClassName="thumb"
        trackClassName="track"
        value={outbound}
        min={0}
        max={23}
        onChange={setOutbound}
      />

      {/* Return Flight */}
      <p className="flight-label mt">
        Return flight, New York (NYC)
      </p>

      <div className="time-row">
        <span>{formatTime(returnFlight[0])}</span>
        <span>{formatTime(returnFlight[1])}</span>
      </div>

      <ReactSlider
        className="slider"
        thumbClassName="thumb"
        trackClassName="track"
        value={returnFlight}
        min={0}
        max={23}
        onChange={setReturnFlight}
      />
    </div>
  );
};

export default DurationSlider;